import React from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { Checkbox } from 'wix-ui-tpa/cssVars';
import { useFormActions } from '../../Hooks/useFormActions';

export interface BookForSomeoneElseCheckboxProps {
  isBookingForSomeoneElse: boolean;
}

const BookForSomeoneElseCheckbox: React.FC<BookForSomeoneElseCheckboxProps> = ({
  isBookingForSomeoneElse,
}) => {
  const { t } = useTranslation();
  const { setIsBookingForSomeoneElse } = useFormActions();

  return (
    <Checkbox
      data-hook="book-for-someone-else-checkbox"
      checked={isBookingForSomeoneElse}
      label={t('bookings.form.bookForSomeoneElse.checkbox.label')}
      onChange={({ checked }) => setIsBookingForSomeoneElse(checked)}
    />
  );
};

export default BookForSomeoneElseCheckbox;
